import workflowApi from '@/api/workflow/workflow'
import { globalModule } from '@/store/moduleName'
import { breakSubErrors } from '@/utils/messageUtil'
import { OUTBOX_FILE_TYPE } from '@/constant/constant'

export const downloadMethod = {
  methods: {
    // deprecated
    downloadZip (attachmentTypeId, formAttributeId, workItemId) {
      workflowApi.downloadAttachmentsZip(attachmentTypeId, formAttributeId, workItemId, resp => {
        if (resp.status === 201 || resp.status === 200) {
          const url = window.URL.createObjectURL(new Blob([resp.data]))
          const link = document.createElement('a')
          link.href = url
          let filename = (attachmentTypeId === OUTBOX_FILE_TYPE.ATTACHMENT) ? 'attachments.zip' : 'reference.zip'
          link.setAttribute('download', filename)
          link.click()
          window.URL.revokeObjectURL(url)
        }
      })
    },

    // item: workflow item object
    // documentType: 2 - attachment, 3 - reference
    // documentType, workItemId: optional, if provided, get the specific version and type attachment, otherwise, get the latest version of all attachment
    downloadAttachments (item, documentType = OUTBOX_FILE_TYPE.ATTACHMENT, workItemId) {
      let body = {
        formAttributeId: item.formAttributeId,
        formCode: item.formCode,
        attachmentTypeId: documentType
      }
      if (workItemId !== undefined) {
        body.workItemId = workItemId
      }
      workflowApi.downloadAttachments(body, resp => {
        if (resp.status === 201 || resp.status === 200) {
          const url = window.URL.createObjectURL(new Blob([resp.data]))
          const link = document.createElement('a')
          link.href = url
          let disposition = resp.headers['content-disposition']
          let filename = disposition.slice(disposition.lastIndexOf('=') + 1).replace(/"/g, '')
          link.setAttribute('download', filename)
          link.click()
          window.URL.revokeObjectURL(url)
        }
      })
    }

  }
}
